import { useCallback } from 'react';
import { endpoints } from '../network';
import { useApiMutation } from '../../../infra/api';
export var useApplyTax = function (itemType, brandId, taxRef) {
    var mutation = useApiMutation({
        endpoint: endpoints.applyBrandTaxMutation,
    });
    return useCallback(function (item, newValue) {
        var _a, _b;
        var locations = (_a = taxRef.current) === null || _a === void 0 ? void 0 : _a.assignments.map(function (assignment) {
            return {
                id: assignment.ownerId,
            };
        });
        // when updating service/product assignments, we send one changed item and a list of all locations
        return mutation.mutateAsync({
            taxId: (_b = taxRef.current) === null || _b === void 0 ? void 0 : _b.id,
            brandId: brandId,
            locations: locations,
            items: [
                {
                    id: item.id,
                    type: itemType,
                    deleted: !newValue,
                },
            ],
        });
    }, []);
};
